import React from 'react'
const TabNavItem = ({id,title,icon,activeTab,setActiveTab}) => {
    const handleClick = () => {
        setActiveTab(id);
    }
    return ( 
        <li onClick={handleClick} className={activeTab === id ? "nav-link active":"nav-link"}>
         <i className={icon}> </i>
         <small> &nbsp;{title}</small>
    </li>
     );
}
 
export default TabNavItem; 